import React from 'react';
import Layout from '@/pages/_layout';
import Exception from '@/components/Exception';
export default () => (
  <Layout>
    <Exception
      type="404"
      desc='抱歉，你访问的页面不存在'
      backText="返回首页"
      />
  </Layout>
);
